import * as React from 'react';

const RowTabButton = ({ id , title , index , selectedTab , tabRowId , handleChange , tabRef  })=>{
    const handleClick = ()=>handleChange(index)
    ;
    return /*#__PURE__*/ React.createElement("li", {
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("button", {
        role: "tab",
        id: id,
        "aria-selected": selectedTab === index,
        "aria-controls": tabRowId,
        tabIndex: selectedTab === index ? 0 : -1,
        onClick: handleClick,
        ref: tabRef
    }, title));
};

export { RowTabButton, RowTabButton as default };
//# sourceMappingURL=RowTabButton.js.map
